
export default {
  computed: {
    // The five Flow screens genuinely differ in width, so this is a per-route
    // lookup rather than one hardcoded value (design-system.md §4). The signup
    // steps beyond the fork narrow further, but they are all `/register`, so
    // the step-level widths are applied by `_signup.scss` on the inner card.
    wrapMaxWidth() {
      const byRoute = {
        "/register": "940px",
        "/register/new-submission": "1180px",
        // Step 5's compressed card (asana-1381) is a reading column, not a
        // grid — the founder's reference layout sets it at 760px.
        "/membership": "760px",
      };
      return byRoute[this.$route.path] || "940px";
    },
    // "Already registered? Sign in." belongs to the pre-auth signup entry only.
    // The four signup steps all live at `/register`; everything past the fork
    // (`/register/new-submission`, `/complete`, `/expert-profile`) is reached by
    // a user who has just registered, where the prompt is nonsense.
    showSignInLink() {
      return this.$route.path === "/register";
    },
  },
};
